// TODO: update content

export default [
  {
    title: 'Buhain',
    dir: 'Buhain',
    description: '2-Bedroom Condominium Unit',
    location: 'Avida Towers Vita',
    to: '/projects/1',
    imgSrc: 'Buhain/1.png',
    routeMatch: 1,
    noOfPics: 7,
    meta: {
      sqm: 55
    }
  },
  {
    title: 'Lavides',
    dir: 'Lavides',
    description: '3-Bedroom Condominium Unit',
    location: 'The Grove by Rockwell',
    to: '/projects/2',
    imgSrc: 'Lavides/1.png',
    routeMatch: 2,
    noOfPics: 8,
    meta: {
      sqm: 103
    }
  },
  {
    title: 'Phua',
    dir: 'Phua',
    description: '1-Bedroom Condominium Unit',
    location: 'Park Terraces',
    to: '/projects/3',
    imgSrc: 'Phua/1.png',
    routeMatch: 3,
    noOfPics: 10,
    meta: {
      sqm: 75
    }
  }
]
